import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { BaseCoreState, basePspBranchActions, basePspBranchSelectors } from '../../../_store';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class BasePspBranchListGuard {
  constructor(private store: Store<BaseCoreState>) {}

  canActivate(): Observable<boolean> {
    this.store.dispatch(basePspBranchActions.loadPspBranchList());

    return this.store.select(basePspBranchSelectors.getPspBranchList).pipe(
      filter((state) => state.ok !== undefined),
      map((state) => state.ok as boolean)
    );
  }
}
